var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaution = function SvgCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ca,.cc{fill:#74757d;}.ca{stroke:#707070;}.cb{clip-path:url(#ca);}.cd,.cf{fill:none;}.cd{stroke:#74757d;stroke-width:2px;}.ce{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ca",
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1654 -290)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cb",
    transform: "translate(1656 292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M-4.611-17.375v4.041L-3.994-6.9h2.123l.616-6.438v-4.041ZM-2.967-4.933a1.715,1.715,0,0,0-1.758,1.8A1.747,1.747,0,0,0-2.967-1.3,1.734,1.734,0,0,0-1.209-3.13,1.7,1.7,0,0,0-2.967-4.933Z",
    transform: "translate(14.725 21.375)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cd",
    transform: "translate(1654 290)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ce",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cf",
    cx: 14,
    cy: 14,
    r: 13
  })))));
};
export default SvgCaution;